<form novalidate [formGroup]="commentForm">
    <h2 mat-dialog-title>
        {{ title ? title : ('moi.commentsDialog.defaultTitle' | transloco) }}
    </h2>
    <mat-dialog-content style="min-width: 750px">
        @if (loading) {
            <div class="fancy-loader"></div>
        } @else {
            <mat-tab-group
                (selectedTabChange)="tabChange($event)"
                mat-align-tabs="center"
                animationDuration="0ms"
            >
                <mat-tab [label]="'moi.commentsDialog.tabComment' | transloco">
                    <div class="container">
                        <div class="input-container pt-3">
                            @if (showProgress) {
                                <div>
                                    <mat-label>{{ 'moi.commentsDialog.progressLabel' | transloco }}</mat-label>
                                    <mat-slider
                                        min="0"
                                        max="100"
                                        step="5"
                                        discrete
                                        thumbLabel
                                        showTickMarks
                                        ><input matSliderThumb formControlName="progress" />
                                    </mat-slider>
                                </div>
                            }

                            @if (showFeasibility) {
                                <mat-form-field>
                                    <mat-label>{{ 'moi.commentsDialog.feasibilityLabel' | transloco }}</mat-label>
                                    <mat-select formControlName="feasibilityId">
                                        <mat-option>{{ 'moi.commentsDialog.feasibilityNone' | transloco }}</mat-option>
                                        @for (feasibility of feasibilities; track feasibility) {
                                            <mat-option [value]="feasibility.id">
                                                {{ feasibility.name }}
                                            </mat-option>
                                        }
                                    </mat-select>
                                </mat-form-field>
                            }

                            <mat-label>{{ 'moi.commentsDialog.commentLabel' | transloco }}</mat-label>
                            <cerrix-textarea
                                data-uiid="moi-comments-comment-textarea"
                                [errorLabel]="'moi.commentsDialog.commentLabel' | transloco"
                                formControlName="comment"
                                [rows]="maxCommentRows"
                                [required]="commentRequired"
                            ></cerrix-textarea>
                        </div>
                    </div>
                </mat-tab>
                @if (comment.id && comment.id > 0) {
                    <mat-tab [label]="'moi.commentsDialog.tabHistory' | transloco">
                        <div class="container">
                            @if (histories) {
                                <table mat-table [dataSource]="histories" class="col-md-12">
                                    <ng-container matColumnDef="modifiedAt">
                                        <th mat-header-cell *matHeaderCellDef>{{ 'moi.commentsDialog.historyEditedOn' | transloco }}</th>
                                        <td mat-cell *matCellDef="let history">
                                            {{ history.modifiedAt | dateFormat }}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="action">
                                        <th mat-header-cell *matHeaderCellDef>{{ 'moi.commentsDialog.historyAction' | transloco }}</th>
                                        <td mat-cell *matCellDef="let history">
                                            {{ history.action }}
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="modifiedBy">
                                        <th mat-header-cell *matHeaderCellDef>{{ 'moi.commentsDialog.historyEditedBy' | transloco }}</th>
                                        <td mat-cell *matCellDef="let history">
                                            {{ history.modifiedBy }} <br />
                                            <i>{{ history.modifiedByRole }}</i>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="comment">
                                        <th mat-header-cell *matHeaderCellDef>{{ 'moi.commentsDialog.historyComment' | transloco }}</th>
                                        <td mat-cell *matCellDef="let history">
                                            {{ history.comment }}
                                        </td>
                                    </ng-container>

                                    <tr
                                        mat-header-row
                                        *matHeaderRowDef="columnsToDisplay; sticky: true"
                                    ></tr>
                                    <tr
                                        mat-row
                                        *matRowDef="let history; columns: columnsToDisplay"
                                    ></tr>
                                </table>
                            } @else {
                                <div class="fancy-loader"></div>
                            }
                        </div>
                    </mat-tab>
                }
            </mat-tab-group>
        }
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button
            mat-button
            data-uiid="moi-comments-save-button"
            [disabled]="!commentForm.valid"
            (click)="saveClick()"
        >
            {{ 'moi.commentsDialog.saveBtn' | transloco }}
        </button>
        <button mat-button mat-dialog-close>{{ 'moi.commentsDialog.cancelBtn' | transloco }}</button>
    </mat-dialog-actions>
</form>
